import {isNoValue} from '@/utils/util'

const channelManage = {
  state: {
    params: {
      casetype: 0,
      channelCode: null,
      channelType: null,
      messagetype: null,
      grade: null,
      name: null,
      phoneNumber: null,
      sortType: null,
      parentId: null,
      number: 1,
      size: 6
    },
    staticParams: {
      channelCode: null,
      channelId: null,
      channelName: null,
      endDate: null,
      forecastType: null,
      startDate: null,
      number: 1,
      size: 10
    },
    formState: {
      visible: false,
      id: null,
      tabPosition: null
    },
    formData: {
      adultUnitPrice: 0,
      amateurUnitPrice: 0,
      channelType: null,
      fullUnitPrice: 0,
      grade: null,
      name: '',
      phoneNumber: ''
    }
  },
  getters: {
    channelManageParams: (state) => {
      return state.params
    },
    channelManageStaticParams: (state) => {
      return state.staticParams
    },
    formatedChannelManageStaticParams: (state) => {
      let result = {}
      for (const key in state.staticParams) {
        const element = state.staticParams[key]
        if (!isNoValue(element)) result[key] = element
      }
      return result
    },
    channelManageFormState: (state) => {
      return state.formState
    }
  },
  mutations: {
    resetChannelManageParams: (state) => {
      state.params = {
        channelCode: null,
        channelType: null,
        grade: null,
        name: null,
        phoneNumber: null,
        sortType: null,
        number: 1,
        size: 10
      }
    },
    resetChannelManageStaticParams: (state) => {
      state.staticParams = {
        channelCode: null,
        channelId: null,
        channelName: null,
        endDate: null,
        forecastType: null,
        startDate: null,
        number: 1,
        size: 10
      }
    }
  },
  actions: {
  }
}

export default channelManage



// WEBPACK FOOTER //
// ./src/store/modules/channel-manage.js